import { useTourStore } from '@/stores/tour'
import { useModuleStore } from '@/stores'

export function useTourHelpers() {
    const hasShownTour = ref(false)

    const launchTour = async (router) => {
        const tourStore = useTourStore()

        const tourStoreModule = await tourStore.getFirstStepModule()
        if (!tourStoreModule || hasShownTour.value) {
            // Tour isn't launching so return false
            return false
        }

        const moduleStore = useModuleStore()
        const { homepageAnimation } = useAnimations()

        hasShownTour.value = true
        moduleStore.addModule(tourStoreModule)
        router.push({ name: 'view', params: { id: tourStoreModule.id } }, homepageAnimation)
        return true
    }

    return {
        launchTour,
    }
}
